import { makeAuthenticatedRequest } from "./api";

export const fetchWrongQuestions = async (classroomId, studentId, query = {},) => {
  try {
    let queryParams = '?'
    if(studentId) {
      queryParams += `studentId=${studentId}`
    }
    if(query?.page) {
      queryParams += `${queryParams === '?' ? '' : '&'}page=${query.page}`
    }
    if(query?.limit) {
      queryParams += `${queryParams === '?' ? '' : '&'}limit=${query.limit}`
    }
    if(query?.subjectId) {
      queryParams += `${queryParams === '?' ? '' : '&'}subjectId=${query.subjectId}`
    }
    if(query?.examType) {
      queryParams += `${queryParams === '?' ? '' : '&'}examType=${query.examType}`
    }
    if(query?.hasIeltsExams === true) {
      queryParams += `${queryParams === '?' ? '' : '&'}hasIeltsExams=${query.hasIeltsExams}`
    }
    const URL = `/topics/${classroomId}/getWrongAnswersReport${
      queryParams
    }`;
    return await makeAuthenticatedRequest(
      URL,
      "GET",
      null
    )
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error fetching wrong questions report:", error);
    return { ok: false, error: error };
  }
};

export const getGrowthProgress = async (classroomId, studentId) => {
  try {
    const URL = `/topics/${classroomId}/growthProgress${
      studentId ? `?studentId=${studentId}` : ""
    }`;
    return await makeAuthenticatedRequest(
      URL,
      "GET",
      null
    )
      .then((response) => {
        if (!response.ok) {
          return { ok: false, error: response };
        }
        return response.json();
      })
      .then((data) => {
        // Transform the data to match the expected structure
        const transformedData = {
          basic: {
            count: data.basic?.length || 0,
            topics:
              data.basic?.map((topic) => ({
                id: topic._id,
                name: topic.name,
                subjectId: topic.subjectId,
                score: parseFloat(topic.score),
                unAttemptedPractices: topic.unAttemptedPractices || [],
                unAttemptedTests: topic.unAttemptedTests || [],
              })) || [],
          },
          inProgress: {
            count: data.inprogress?.length || 0,
            topics:
              data.inprogress?.map((topic) => ({
                id: topic._id,
                name: topic.name,
                subjectId: topic.subjectId,
                score: parseFloat(topic.score),
                unAttemptedPractices: topic.unAttemptedPractices || [],
                unAttemptedTests: topic.unAttemptedTests || [],
              })) || [],
          },
          mastered: {
            count: data.master?.length || 0,
            topics:
              data.master?.map((topic) => ({
                id: topic._id,
                name: topic.name,
                subjectId: topic.subjectId,
                score: parseFloat(topic.score),
                unAttemptedPractices: topic.unAttemptedPractices || [],
                unAttemptedTests: topic.unAttemptedTests || [],
              })) || [],
          },
        };
        return { ok: true, data: transformedData };
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        return { ok: false, error: error };
      });
  } catch (error) {
    console.error("Error fetching growth progress:", error);
    return { ok: false, error: error };
  }
};
